import React, { useEffect,useState } from 'react'
import { useLocation } from 'react-router-dom';
import { BINDING_ACTIVE, BINDING_CONFIRMED } from '../../constant';
import * as style from './BindingResult.module.css'
import Util from '../../utils/utils';

const BindingResult = () => {
    const location = useLocation();
    const [contentData, setContentData] = useState(null);
    useEffect(() => {
        document.title = 'Kết quả liên kết';
        const params = location.state;
        console.log('params', params)
        if (!params) return;
        Util.showLoading();
        if (params.status === BINDING_ACTIVE) {
            setContentData({
                logo: "https://scdn.zalopay.com.vn/data/agp/authorize-fe/success-v2.png",
                title:"Liên kết với ví Zalopay thành công",
                message: "Bạn đã liên kết Zalopay thành công. Vui lòng đóng trang này để tiếp tục."
            })
        }else {
            setContentData({
                logo: "https://scdn.zalopay.com.vn/data/agp/authorize-fe/failed.png",
                title:"Liên kết với ví Zalopay thất bại",
                message: "Liên kết Zalopay chưa thành công hoặc đã tồn tại. Vui lòng kiểm tra lại."
            })
        }
        Util.hideLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main>
            <div className={style.imgSection}>
                <img src={contentData?.logo} alt={"logo"} />
            </div>
            <div className={style.messageSection}>
                <h1>{contentData?.title}</h1>
                <p>{contentData?.message}</p>
            </div>
        </main>
    )
}

export default BindingResult;
